/**
 * 트리거 설정 UI 문자열 리소스
 * signal-trigger, trailing, overlapping, exclusive 등
 */
export const triggerStr = {
  title: {
    unsavedChanges: '[{type}] 저장되지 않은 변경사항',
  },
  message: {
    unsavedConfirm: '저장되지 않은 변경사항이 있습니다. 저장하시겠습니까?',
    ratioSum100: '진입 수량 비율의 합은 100%가 되어야 합니다.',
    noSelectedSignalType: '선택된 신호 타입이 없습니다.',
    noSelectedCondition: '선택된 조건이 없습니다.',
    strategyUpdated: '{name} 전략이 업데이트되었습니다.',
    roeCannotBeZero: '수익률은 0이 될 수 없습니다.',
  },
  header: {
    signal: '신호',
    dropRatio: '최고가 대비 하락률',
    riseRatio: '최저가 대비 상승률',
    evalDropRatio: '최대 평가 씨드액 대비 하락률',
    exitRatio: '{type} 비율',
    amountRatio: '{type} 수량 비율',
    remaining: '(잔량의)',
    roePercent: '순익률(+/-)',
    total: '합계',
  },
  label: {
    belowWhen: '이하로 하락 시',
    aboveWhen: '이상으로 상승 시',
    below: ' 이하',
    above: ' 초과',
    fallingWhen: '{type} 시',
    risingWhen: '{type} 시',
  },
  validation: {
    selectSignal: '신호를 선택하세요.',
    greaterThanZero: '0보다 큰 숫자를 입력해주세요.',
    positiveNumber: '양수 숫자를 입력하세요.',
    nonZeroNumber: '0이 아닌 숫자를 입력해주세요.',
  },
};
